'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../utils');

var u = _interopRequireWildcard(_utils);

var _DefOption = require('./DefOption');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Option = exports.Option = function (_React$Component) {
  _inherits(Option, _React$Component);

  function Option() {
    _classCallCheck(this, Option);

    var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this));

    _this.updateFocus = function () {
      if (_this.props.focused && _this.optionRef.current) _this.optionRef.current.focus();
    };

    _this.handleKeyDown = function (event) {
      if (event.which === 13 || event.which === 32) {
        // Enter || Space
        _this.props.onClick();
        u.stopPreventPropagation(event);
      }
    };

    _this.state = {
      hovered: false
    };

    _this.optionRef = _react2.default.createRef();
    return _this;
  }

  _createClass(Option, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateFocus();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateFocus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var s = this.state,
          p = this.props;


      return _react2.default.createElement(
        'label',
        {
          className: u.classes('Option', {
            'Option--focus': p.focused,
            'Option--hover': s.hovered
          }),
          role: 'option',
          'aria-selected': p.checked,
          tabIndex: '-1',
          ref: this.optionRef,
          onMouseDown: p.onClick,
          onKeyDown: this.handleKeyDown,
          onMouseOver: function onMouseOver() {
            return _this2.setState({ hovered: true });
          },
          onMouseOut: function onMouseOut() {
            return _this2.setState({ hovered: false });
          }
        },
        _react2.default.createElement(p.Option, {
          option: p.option,
          checked: p.checked,
          isSingle: p.isSingle
        })
      );
    }
  }]);

  return Option;
}(_react2.default.Component);

Option.displayName = 'Option';
Option.propTypes = {
  Option: _propTypes2.default.func,
  option: _propTypes2.default.object.isRequired,
  checked: _propTypes2.default.bool,
  focused: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  isSingle: _propTypes2.default.bool
};
Option.defaultProps = {
  Option: _DefOption.DefOption
};